import React from 'react';
import { MuiFormControlLabel, MuiCheckbox, CheckboxProps } from 'theme/material-ui';

type OmittedProps = 'color' | 'onChange';
type MuiCheckboxProps = Omit<CheckboxProps, OmittedProps>;

export interface ConnectCareCheckboxItemProps extends MuiCheckboxProps {
  label?: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked?: boolean) => void;
}

function ConnectCareCheckboxItem(props: ConnectCareCheckboxItemProps) {
  const { label, onChange, ...rest } = props;

  return (
    <MuiFormControlLabel
      label={label}
      control={
        <MuiCheckbox
          {...rest}
          color="primary"
          onChange={(e, checked) => onChange && onChange(e, checked)}
        />
      }
    />
  );
}

export default ConnectCareCheckboxItem;
